import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { useMemo } from "react";
import { newsStaticData } from "../../constant/newsStaticData";
import { formatDate } from "../../constant/utils";
import "./NewsList.css";
import { Link } from "react-router-dom";

export default function NewsList() {
  // Memoize sorted news data
  const sortedNews = useMemo(
    () =>
      newsStaticData().sort(
        (a, b) => new Date(b.published) - new Date(a.published)
      ),
    []
  );

  return (
    <section className="news-section">
      <div className="left-side">
        <h2 className="news-heading">News & Articles</h2>
        <p className="news-subheading">
          Bataiyo has been featured across leading publications for
          revolutionizing how people connect - with zero commission, genuine
          trust, and real stories that truly matter.
        </p>
      </div>

      <div className="news-list">
        {sortedNews.map((news, index) => (
          <Link
            key={news.id}
            className="news-card"
            to={news.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="news-card-box">
              <p className="news-meta">
                {news.channelName.toUpperCase()}
                <span>• {formatDate(news.published)}</span>
              </p>
              <p className="news-title">{news.title}</p>
            </div>
            <div className="arrow-icon">
              <ArrowOutwardIcon />
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
